import { defineMessages } from 'react-intl';

export default defineMessages({
    paymentOptions: {
        id: 'quoteandbind.views.payment-details.Payment Options',
        defaultMessage: 'Payment Options',
    },
    averageMonthlyPremium: {
        id: 'quoteandbind.views.payment-details.Average Monthly Premium',
        defaultMessage: 'Average Monthly Premium:',
    },
    paymentDetails: {
        id: 'quoteandbind.views.payment-details.Payment Details',
        defaultMessage: 'Payment Details',
    },
    totalPremium: {
        id: 'quoteandbind.views.payment-details.Total Premium:',
        defaultMessage: 'Total Premium:',
    },
    paymentBuyNow: {
        id: 'quoteandbind.views.payment-details.Buy Now',
        defaultMessage: 'Buy Now'
    },
    billingMethod: {
        id: 'quoteandbind.views.payment-details.Billing Method',
        defaultMessage: 'Billing Method'
    },
    // paymentMethod: {
    //     id: 'quoteandbind.views.payment-details.Payment Method',
    //     defaultMessage: 'Payment Method'
    // }, 
    withdrawalDayofMonth: {
        id: 'quoteandbind.views.payment-details.Withdrawal Day of Month',
        defaultMessage: 'Withdrawal Day of Month'
    },
    downPayment: {
        id: 'quoteandbind.views.payment-details.Down Payment',
        defaultMessage: 'Down Payment'
    },
    issuePolicy: {
        id: 'quoteandbind.views.payment-details.Issue Policy',
        defaultMessage: 'Issue Policy'
    },
    payUsing: {
        id: 'quoteandbind.views.payment-details.Pay Using',
        defaultMessage: 'Pay Using'
    },
    modelError: {
        id: 'quoteandbind.views.payment-details.Error',
        defaultMessage: 'Error'
    },
    paymentListError: {
        id: 'quoteandbind.views.payment-details.Unable to get Payment list. Please contact administrator',
        defaultMessage: 'Unable to get Payment list. Please contact administrator'
    },
    billingMethodChangeError: {
        id: 'quoteandbind.views.payment-details.Unable to save billing method changes. Please contact system administrator',
        defaultMessage: 'Unable to save billing method changes. Please contact system administrator'
    },
    creditCardError: {
        id: 'quoteandbind.views.payment-details.Credit Card Error',
        defaultMessage: 'Credit Card Error'
    },
    creditCardEmptyError: {
        id: 'quoteandbind.views.payment-details.Please fill all credit card details',
        defaultMessage: 'Please fill all credit card details'
    },
    paymentStatus: {
        id: 'quoteandbind.views.payment-details.Payment Status',
        defaultMessage: 'Payment Status'
    },
    paymentAddedSuccessfully: {
        id: 'quoteandbind.views.payment-details.Payment Added Successfully',
        defaultMessage: 'Payment Added Successfully'
    },
    paymentAddFailure: {
        id: 'quoteandbind.views.payment-details.Payment Add Failure',
        defaultMessage: 'Payment Add Failure'
    },
    bankdetailsEmptyError: {
        id: 'quoteandbind.views.payment-details.Please fill bank details',
        defaultMessage: 'Please fill bank details'
    },
    instituteSearchError: {
        id: 'quoteandbind.views.payment-details.Error occurred while searching',
        defaultMessage: 'Error occurred while searching'
    },
    instituteSearchErrorDetails: {
        id: 'quoteandbind.views.payment-details.Error occurred while searching bank information. Please try after sometime.',
        defaultMessage: 'Error occurred while searching bank information. Please try after sometime.'
    },
    modelSelect: {
        id: 'quoteandbind.views.payment-details.Select',
        defaultMessage: 'Select'
    },
    modelValidate: {
        id: 'quoteandbind.views.payment-details.Validate',
        defaultMessage: 'Validate'
    },
    modelSubmit: {
        id: 'quoteandbind.views.payment-details.Submit',
        defaultMessage: 'Submit'
    },
    modelCancel: {
        id: 'quoteandbind.views.payment-details.Cancel',
        defaultMessage: 'Cancel'
    },
    methodofpayment: {
        id: 'quoteandbind.views.payment-details.Method of payment',
        defaultMessage: 'Method of payment'
    },
    modelReference: {
        id: 'quoteandbind.views.payment-details.Reference',
        defaultMessage: 'Reference'
    },
    modelDescription: {
        id: 'quoteandbind.views.payment-details.Description',
        defaultMessage: 'Description'
    },
    cardHolderName: {
        id: 'quoteandbind.views.payment-details.Card Holder Name',
        defaultMessage: 'Card Holder Name'
    },
    ModeOfReceivingCardInfo: {
        id: 'quoteandbind.views.payment-details.Mode Of Receiving Card Info',
        defaultMessage: 'Mode Of Receiving Card Info'
    },
    InstitutionNumber: {
        id: 'quoteandbind.views.payment-details.Institution Number',
        defaultMessage: 'Institution Number'
    },
    modelChequing: {
        id: 'quoteandbind.views.payment-details.Chequing',
        defaultMessage: 'Chequing'
    },
    modelSavings: {
        id: 'quoteandbind.views.payment-details.Savings',
        defaultMessage: 'Savings'
    },
    bankAccountType: {
        id: 'quoteandbind.views.payment-details.Bank Account Type',
        defaultMessage: 'Bank Account Type'
    },
    accountNumber: {
        id: 'quoteandbind.views.payment-details.Account Number',
        defaultMessage: 'Account Number'
    },
    bankAccountHolder: {
        id: 'quoteandbind.views.payment-details.Bank Account Holder',
        defaultMessage: 'Bank Account Holder'
    },
    transitNumber: {
        id: 'quoteandbind.views.payment-details.Transit Number',
        defaultMessage: 'Transit Number'
    },
    transitNumber: {
        id: 'quoteandbind.views.payment-details.Institution Number',
        defaultMessage: 'Institution Number'
    },
    transitNumber: {
        id: 'quoteandbind.views.payment-details.Institution Name',
        defaultMessage: 'Institution Name'
    },
    tenerateSigningPackage: {
        id: 'quoteandbind.views.payment-details.Generate Signing Package',
        defaultMessage: 'Generate Signing Package'
    },
    notes: {
        id: 'quoteandbind.views.payment-details.Notes',
        defaultMessage: 'Notes'
    },
    paymentMethodChangeError: {
        id: 'quoteandbind.views.payment-details.This combination of payment plan and payment method is not allowed.',
        defaultMessage: 'This combination of payment plan and payment method is not allowed.'
    },
    premiumUpdatedNotification: {
        id: 'quoteandbind.views.payment-details.Your recent action resulted change in Premium. Please review the Total Premium',
        defaultMessage: 'Your recent action resulted change in Premium. Please review the Total Premium'
    },
    payUsingCCError: {
        id: 'quoteandbind.views.payment-details.Please select a Preauthorized Credit Card for payment',
        defaultMessage: 'Please select a Preauthorized Credit Card for payment'
    },
    payUsingBAError: {
        id: 'quoteandbind.views.payment-details.Please select a Preauthorized Bank Account for payment',
        defaultMessage: 'Please select a Preauthorized Bank Account for payment'
    },
    confirmationOfSignAndDoc: {
        id: 'quoteandbind.views.payment-details.Please confirm collection of all signatures and relevant documentation prior to issuing',
        defaultMessage: 'Please confirm collection of all signatures and relevant documentation prior to issuing',
    },
    brokerDeclaration: {
        id: 'quoteandbind.views.payment-details.Broker Declaration',
        defaultMessage: 'Broker Declaration',
    },
    modalWarning: {
        id: 'quoteandbind.views.payment-details.modalWarning',
        defaultMessage: 'New underwriting issues have been raised. Please review and/or refer to underwriter.'
    }

});
